module.exports = __webpack_public_path__ + "static/media/ils_esign_failed_fisdom.00746b48.svg";